import React, { useContext } from 'react';

import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { ErrorTitle } from './common/error_title';
import { ErrorContent } from './common/error_content';
import { Separator } from '../products/products/common/separator';
import { StartNewQuoteButton } from './common/start_new_quote_button';
import { SergeiShocked } from './common/sergei_shocked';
import { sergeiShockedImgPath } from './common/preload_image';

const useStyles = createUseStyles((theme) => ({
    applicationErrorXsContainer: {
    },
    header: {
        height: '16rem',
        position: 'relative',
        background: 'linear-gradient(223.17deg, rgba(231, 240, 251, 0.8) 28.29%, rgba(144, 189, 234, 0.8) 104.11%), #FFFFFF',
        borderRadius: '0% 0% 90% 80% / 0% 0% 40% 30%',
        overflow: 'hidden'
    },
    title: {
        width: '50%',
        paddingTop: '4.4rem',
        paddingLeft: theme.spacing[16]
    },
    picture: {
        position: 'absolute',
        right: '-6.5rem',
        top: 0,
        height: '15.8rem',
        objectFit: 'cover',
        objectPosition: 'top',
        width: '28rem'
    },
    errorContent: {
        paddingTop: theme.spacing[16],
        paddingLeft: theme.spacing[16],
        paddingRight: theme.spacing[16]
    },
    separatorBox: {
        marginTop: theme.spacing[16],
        marginBottom: theme.spacing[16]
    },
    buttonBox: {
        marginRight: theme.spacing[16],
        display: 'flex',
        justifyContent: 'flex-end'
    }
}));

const ApplicationErrorInfoXs = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classes.applicationErrorXsContainer}>
            <div className={classNames(classes.header)}>
                <ErrorTitle className={classes.title} />
                <SergeiShocked className={classes.picture} imgSrc={sergeiShockedImgPath} />
            </div>
            <ErrorContent className={classes.errorContent} />
            <Separator type="horizontal" className={classes.separatorBox} />
            <div className={classes.buttonBox}>
                <StartNewQuoteButton />
            </div>
        </div>
    );
};

export { ApplicationErrorInfoXs };
